// @ts-nocheck
import * as _18 from "./cosmos";
export const cosmos_proto = {
  ..._18
};